import {
    ArrowGreenUpContainer,
    CardTitle,
    PercentageText,
    StatusIndicatorContainer,
    useStyles,
} from "./styles";
import { ReactComponent as Arrow } from 'assets/images/arrowRight.svg';
import Intercom from "helpers/Intercom";
import { SymphonyTooltip } from 'modules/Sty';
import ArticleTitle, { Article } from 'components/shareable/ArticleTitle';
import useBrand from 'Hooks/useBrand';
import useFans from "Hooks/useFans";
import Stat from "elements/Stat";
import useScreen from "Hooks/useScreen";
import Loader from "elements/Loader";

interface Props {
    icon: string,
    title: string | JSX.Element,
    percentage?: string,
    total: number,
    mobile?: boolean,
    elementKey?: string,
}

const FanCardMetrics = ({
    icon,
    title,
    total,
    percentage,
    mobile = true,
    elementKey
}: Props) => {
    const classes = useStyles();
    const { isProBrand } = useBrand()
    const { isLoadingMetrics } = useFans()

    const openIntercomArticle = () => {
        Intercom.openForeverSavesArticle();
    }

    const getFormattedTotal = () => {
        return total.toLocaleString();
    }

    const getFormattedPercentage = () => {
        return `${percentage} %`
    }

    const getCardTitle = () => {
        const titleElement = <CardTitle>{title}</CardTitle>;
        if (elementKey !== 'forever-presave-fans') {
            return titleElement;
        }

        if (isProBrand) {
            return (
                <ArticleTitle
                    children={titleElement}
                    article={Article.ForeverSaves}
                    toolTipText='Click to learn more about how Forever Saves work.'
                />
            )
        }

        return (
            <SymphonyTooltip title="Upgrade to Symphony Pro to unlock Forever Saves. Click to learn more.">
                <CardTitle onClick={openIntercomArticle}>
                    {title}
                </CardTitle>
            </SymphonyTooltip>
        )
    }

    return (
        <Stat
            className="cardMetricsComponent"
            icon={icon}
            isHorizontal
            title={
                isLoadingMetrics ?
                    <Loader
                        className="cardMetricsLoader"
                        style={{ width: 'fit-content' }}
                        size={27}
                    />
                    :
                    total
            }
            subtitle={getCardTitle()}
            rightSideContent={
                <StatusIndicatorContainer>
                    <ArrowGreenUpContainer>
                        <Arrow className={classes.svgGreen} />
                    </ArrowGreenUpContainer>
                    {percentage &&
                        <PercentageText>
                            {getFormattedPercentage()}
                        </PercentageText>
                    }
                </StatusIndicatorContainer>
            }
        />
    )
}

export default FanCardMetrics;
